import Vue from 'vue';
import firebase from 'firebase/app';

const state = {
  mentions: [],
  mentions_length: 0,
};

const mutations = {
  LOAD_DATA(state, data) {
    state.mentions = data;
  },
};

const actions = {
  activeLoadData: async ({ commit, dispatch, rootGetters }, orgId) => {
    try {
      let inited = true;

      Vue.prototype.$snapshots.$mentions_snapshot = firebase
        .firestore()
        .collection('mentions')
        .doc(
          `@${rootGetters['auth/get_user'].name.replace(/\s+/g, '_')}_${orgId}`
        )
        .onSnapshot((snapshot) => {
          if (inited) {
            inited = false;
          } else {
            const {
              type: notificationType,
              message,
              name,
              owner,
              metadata,
            } = snapshot.data() || { message: '' };

            dispatch(
              'auth/new_notification',
              {
                type: 'mention',
                notification_type: notificationType,
                name,
                owner,
                message,
                metadata,
              },
              { root: true }
            );
          }
        });
    } catch (error) {
      commit('LOAD_DATA', []);
    }
  },
};

const getters = {
  get_user_mentions(state) {
    return state.mentions;
  },
  get_user_mentions_length(state) {
    return state.mentions_length;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
